import { Component, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import * as signalR from '@microsoft/signalr';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { CategoryModel } from 'src/app/models/Category.model';
import { LikeModel, NewsFilterModel, NewsModel } from 'src/app/models/News.model';
import { CommentService } from 'src/app/services/Comment/comment.service';
import { NewsService } from 'src/app/services/News/news.service';
import { environment } from 'src/environments/environment';
import { CommentFilterModel, newCommentModel } from '../../../models/Comment.model';
import { NewsCommentPopoverComponent } from '../news-components/news-comment-popover/news-comment-popover.component';
import { SharedService } from './../../../services/shared/shared.service';

@Component({
  selector: 'app-news-details',
  templateUrl: './news-details.page.html',
  styleUrls: ['./news-details.page.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NewsDetailsPage implements OnInit {
  constructor(
    private routeParams: ActivatedRoute,
    private newsService: NewsService,
    public router: Router,
    private popoverController: PopoverController,
    private sharedService: SharedService,
    public translate: TranslateService,
    private commentService: CommentService,
    private storage: Storage,
    private shareService: SharedService,
    private sanitizer: DomSanitizer,
  ) {
    this.negotiateUrl = environment.apiUrl;
    this.isIphone = /iPhone/i.test(navigator.userAgent);
  }

  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
  public videoCaminhosPath = environment.videoCaminhosPath;
  @ViewChild('targetComment') inputText: any;
  isIphone = false;
  negotiateUrl: string = '';
  editorialId: string = '';
  width!: number;
  newsId: string = '';
  news: NewsModel = new NewsModel();
  fCategory: CategoryModel[] = [new CategoryModel()];
  CategoryId: CategoryModel[] = [new CategoryModel()];
  relatedNews?: NewsModel[];
  liked = true;
  // comments: CommentModel[] = [new CommentModel()];
  // comment: CommentModel = new CommentModel();

  comments?: any;
  comment: any;
  commentId: string = '';
  commentText: string = '';
  newComment: newCommentModel = new newCommentModel();
  sliceRelated = 4;
  batchSize = 5;
  moreRelatedResults = true;
  endRelatedResults = false;
  moreCommentsResults = true;
  endCommentsResults = false;
  isLoading = true;
  notFound = true;
  empty = true;
  fakeElementsLarg = ['', '', '', '', ''];
  userId!: string;
  commentFilterModel: CommentFilterModel = { PageIndex: 0, PageSize: 20 };
  btComment = true;
  editedComment = false;
  fab = false;
  likeLoading = false;
  indexRelatedNews = 0;
  loadInner = false;

  employee = { userName: '', id: '' };
  resize = false;
  cachedEmbedUrl: SafeResourceUrl | null = null;

  @HostListener('window:resize')
  onResize() {
    this.width = window.innerWidth;
    this.resize = true;
  }

  filter: NewsFilterModel = {
    PageIndex: 0,
    PageSize: 20,
  };

  likeConnection: any;
  commentConnection: any;

  async ngOnInit() {
    this.width = window.innerWidth;
    this.likeConnection = new signalR.HubConnectionBuilder().withUrl(`${environment.apiUrl}news/Likes`).build();

    this.commentConnection = new signalR.HubConnectionBuilder().withUrl(`${environment.apiUrl}news/Comments`).build();

    await this.likeConnection.start().then(
      async () => {
        await this.commentConnection.start().then(
          () => {},
          (error: any) => {
            console.error('Error comment connection => ', error);
          },
        );
      },
      (error: any) => {
        console.error('Error like connection => ', error);
      },
    );

    await this.likeConnection.on('Send', async () => {
      await this.refreshLikes();
    });

    await this.commentConnection.on('Comment', async () => {
      await this.refreshComments();
    });

    if (this.videoPlayer && this.news.internVideo && !this.news.internVideo.includes('video_caminhos')) {
      const video = this.videoPlayer.nativeElement;
      video.currentTime = 1;
    }
  }

  async refreshComments() {
    this.commentFilterModel.PageIndex = 0;
    await lastValueFrom(this.commentService.getAllComments(this.commentFilterModel)).then((comments: any) => {
      this.comments = comments;
    });
  }

  async refreshLikes() {
    this.likeLoading = true;
    try {
      const res = await lastValueFrom(this.newsService.getNewsLikes(this.news.id, this.userId));
      this.userId === res.employeeId ? (this.liked = true) : (this.liked = false);
      this.news.Likes = res.totalLikes;
      this.likeLoading = false;
    } catch (error) {
      this.likeLoading = false;
    }
  }

  async ionViewWillEnter() {
    this.routeParams.params.subscribe(params => {
      this.editorialId = this.routeParams.snapshot.paramMap.get('editorialId') ?? '';
      this.newsId = this.routeParams.snapshot.paramMap.get('newsId') ?? '';
    });

    await this.getNews();
    await this.getRelatedNews();
    await this.getFCategory();
    await this.getEmployee();

    let text = document.getElementById('textNews');
    try {
      text!.innerHTML = this.getLocalized(this.news.text) || '';
    } catch {
      this.loadInner = true;
    }
  }

  async getEmployee() {
    await this.storage.get('userName').then(async username => {
      this.employee.userName = username;
      await this.storage.get('employeeId').then(id => {
        this.employee.id = id;
      });
    });
  }

  checkInner() {
    document.getElementById('textNews')!.innerHTML = this.getLocalized(this.news.text) || '';
  }

  getLocalized(field: any): string {
    if (!field) {
      return '';
    }
    if (typeof field === 'string') {
      return field;
    }
    const lang = this.translate.currentLang || 'pt';
    return field[lang] || field['pt'] || '';
  }

  private extractEmbedUrl(rawEmbed: string): string {
    if (!rawEmbed) {
      return '';
    }

    const trimmedEmbed = rawEmbed.trim();
    if (!trimmedEmbed.startsWith('<')) {
      return trimmedEmbed;
    }

    const srcMatch = trimmedEmbed.match(/src=["']([^"']+)["']/i);
    return srcMatch?.[1] ?? '';
  }

  getSafeNewsEmbed(): SafeResourceUrl | null {
    // Retorna a URL em cache para evitar re-renderização desnecessária
    if (this.cachedEmbedUrl !== null) {
      return this.cachedEmbedUrl;
    }

    if (!this.news?.isEmbed) {
      this.cachedEmbedUrl = null;
      return null;
    }

    const localizedEmbed = this.getLocalized(this.news.embed);
    const embedUrl = this.extractEmbedUrl(localizedEmbed);

    if (!embedUrl) {
      this.cachedEmbedUrl = null;
      return null;
    }

    this.cachedEmbedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
    return this.cachedEmbedUrl;
  }

  private initializeEmbedCache() {
    // Pré-computa o embed seguro quando a notícia é carregada
    this.getSafeNewsEmbed();
  }

  async getNews() {
    this.userId = await this.storage.get('id');
    this.commentFilterModel.NewsId = this.newsId;
    this.commentFilterModel.Backoffice = false;
    this.cachedEmbedUrl = null; // Reseta o cache ao carregar nova notícia

    await lastValueFrom(this.newsService.getNewsById(this.newsId)).then(async (response: NewsModel) => {
      this.news = response;
      this.initializeEmbedCache();
      await this.getNewsLikes(response.id);
      await this.getComments();
    });
  }

  async getNewsLikes(id: string) {
    await lastValueFrom(this.newsService.getNewsLikes(id, this.userId)).then(async (newsLikes: LikeModel) => {
      this.news.Likes = newsLikes.totalLikes;
      this.userId === newsLikes.employeeId ? (this.liked = true) : (this.liked = false);
    });
  }

  async getComments(event = false) {
    if (event) {
      this.commentFilterModel.PageIndex += 1;
      this.moreCommentsResults = false;
    }
    await lastValueFrom(this.commentService.getAllComments(this.commentFilterModel)).then((comments: any) => {
      if (event) {
        if (comments.length === 0) {
          this.moreCommentsResults = false;
          this.endCommentsResults = true;
          this.shareService.showToast(this.translate.instant('common.emptyResult'));
        } else {
          this.comments = this.comments.concat(comments);
          this.moreCommentsResults = true;
        }
      } else {
        this.comments = comments;
      }
    });
  }

  async getFCategory() {
    this.news.categoriesIds.forEach(async category => {
      this.filter.CategoryId = category;
      await lastValueFrom(this.newsService.getCategories()).then((res: CategoryModel[]) => {
        this.fCategory = res;
      });
    });
  }

  async getRelatedNews(scroll?: boolean) {
    if (scroll) {
      this.sliceRelated += this.batchSize;
      this.filter.PageIndex++;
      this.filter.Event = true;
      this.moreRelatedResults = false;
    } else {
      this.relatedNews = [];
      this.filter = {
        PageIndex: 0,
        PageSize: 6,
        language: this.translate.currentLang,
        Event: false,
      };
    }

    this.filter.Event ? (this.isLoading = false) : (this.isLoading = true);

    this.editorialId !== 'null' && this.editorialId ? (this.filter.EditorialId = this.editorialId) : null;

    this.filter.CategoryId = this.news.categoriesIds[this.indexRelatedNews];
    this.filter.PageSize = this.batchSize + 1;

    if ((this.relatedNews && this.relatedNews.length < this.sliceRelated) || !this.filter.EditorialId) {
      await lastValueFrom(this.newsService.getNews(this.filter)).then(
        async (res: NewsModel[]) => {
          if (res.length === 0 && this.indexRelatedNews <= 0) {
            this.moreRelatedResults = false;
            this.endRelatedResults = true;
            this.sharedService.showToast(this.translate.instant('common.emptyResult'));
          }
          if (!this.filter.Event) {
            if (res.length > 0) {
              this.relatedNews = res;
              this.moreRelatedResults = true;
            }
          } else {
            this.indexRelatedNews += 1;
            this.relatedNews ? this.relatedNews.push(...res) : null;
            this.moreRelatedResults = true;
          }
          this.isLoading = false;
          this.notFound = false;
        },
        () => {
          this.empty = false;
          this.notFound = true;
          this.isLoading = false;
        },
      );
    } else {
      this.moreRelatedResults = false;
      this.endRelatedResults = true;
      this.sharedService.showToast(this.translate.instant('common.emptyResult'));
    }

    if (this.indexRelatedNews >= this.news.categoriesIds.length) {
      this.moreRelatedResults = false;
      this.endRelatedResults = true;
    } else {
      this.moreRelatedResults = true;
      this.endRelatedResults = false;
    }

    this.relatedNews = this.relatedNews!.filter(y => y.id !== this.news.id);
  }

  async changeParams(id: string, changeParams = false) {
    if (changeParams) {
      this.loadInner = false;
      let text = document.getElementById('textNews');
      if (text) {
        text.remove();
      } else {
        let d = document.createElement('div');
        d.setAttribute('id', 'textNews');

        let a = document.getElementById('divContainer');
        if (a) a.appendChild(d);

        d.remove();
      }
    }
    await this.router.navigateByUrl(this.router.url.replace(this.newsId, id));
  }

  async like() {
    this.likeLoading = true;
    if (!this.liked) {
      let like: LikeModel = {
        employeeId: this.userId,
        newsId: this.news.id,
        totalLikes: 0,
      };
      await this.newsService
        .like(like)
        .toPromise()
        .then(
          () => {
            this.news.Likes += 1;
            this.liked = !this.liked;
            this.likeLoading = false;
          },
          () => {
            this.likeLoading = false;
          },
        );
    } else {
      await this.newsService
        .unLike(this.news.id, this.userId)
        .toPromise()
        .then(
          res => {
            this.news.Likes -= 1;
            this.liked = !this.liked;
            this.likeLoading = false;
          },
          () => {
            this.likeLoading = false;
          },
        );
    }
  }

  async sendComment(nComment = false, id?: string) {
    this.btComment = false;
    this.newComment.employeeName = this.employee.userName;
    this.newComment.newsId = this.news.id;
    this.newComment.languageCode = this.translate.currentLang;
    this.newComment.text = this.commentText;

    if (nComment) this.commentId = '';

    if (id) this.newComment.parentId = id;
    // id ? () : (this.newComment.parentId = '');

    await lastValueFrom(this.commentService.postComment(this.newComment)).then(
      async () => {
        await this.sharedService.showToast(this.translate.instant('toast.success.SendComment'));
        await this.refreshComments();
        this.btComment = true;
      },
      async () => {
        this.btComment = true;
      },
    );

    this.commentId = '';
    this.commentText = '';
  }

  showComment(id: string) {
    this.commentId = id;
    this.commentText = '';
  }

  async showPopover(id: string, comment: any, ev: any) {
    const popover = await this.popoverController.create({
      component: NewsCommentPopoverComponent,
      cssClass: 'my-custom-class',
      event: ev,
      translucent: true,
      mode: 'ios',
      componentProps: { commentId: id, comment: comment },
    });
    await popover.present();

    await popover.onDidDismiss().then(async (data: any) => {
      if (!data.data) {
        return;
      } else if (data.data.comment) {
        await this.scroll('targetComment').then(async () => {
          await this.updateComment(data.data.comment);
        });
      } else if (data.data.refresh) {
        await this.refreshComments();
      }
    });
  }

  async scroll(target: string) {
    setTimeout(() => {
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }
    });
    let el = document.getElementById(target);
  }

  async updateComment(comment?: any, edit = true) {
    setTimeout(() => {
      this.inputText.setFocus();
    }, 1000);

    edit ? (this.editedComment = true) : null;
    edit ? (this.commentText = comment!.text ?? '') : null;
    edit ? (this.comment = comment ?? null) : null;
  }

  async editComment() {
    this.btComment = false;
    this.comment.status = 0;
    this.comment.postDate = new Date();
    this.comment.text = this.commentText;
    this.comment.edited = true;

    await firstValueFrom(this.commentService.editComment(this.comment))
      .then(async () => {
        await this.sharedService.showToast(this.translate.instant('toast.success.SendComment'));
        await this.refreshComments();
        this.commentId = '';
        this.commentText = '';
        this.btComment = true;
        this.editedComment = false;
      })
      .catch(() => {
        this.btComment = true;
      });
  }

  onScroll(event: any) {
    event.target.scrollTop > 600 ? (this.fab = true) : (this.fab = false);
  }

  topCalc(commentsDiv: any) {
    let result = commentsDiv.offsetWidth / 2;
    return result * -1 + 10;
  }

  async gotoComment() {
    await this.scroll('targetComment').then(async () => {
      await this.updateComment(undefined, false);
    });
  }
}
